import { getQuery } from '@/common/const';
// https://docs.corp.kuaishou.com/k/home/Vc82TVC2VoRs/fcADdcJE5FcbpuB1of2sWsR01#section=vodka.7hjrknuh4sxx
// 货架添加归因，通过 URL 参数完成
export type TShelfKeys =
    | 'FLOOR_HOT'
    | 'FLOOR_SAMPLE'
    | 'FLOOR_SUBSIDY'
    | 'SEARCH_SALECOUNT'
    | 'SEARCH_COMMISSION'
    | 'RECO_ALL'
    | 'RECO_FRONTCATEGORY_FACALITYTOOLS'
    | 'RECO_FRONTCATEGORY_HOUSEHOLDGOODS'
    | 'RECO_FRONTCATEGORY_FASHIONLADY'
    | 'RECO_FRONTCATEGORY_BEAURYHEALTH'
    | 'RECO_FRONTCATEGORY_ELECTRONIC'
    | 'ALL_TOPSALES'
    | 'ALL_TOPCOMMISION'
    | 'SHOP_RECO'
    | 'SHOP_TOPSALES'
    | 'SHOP_TOPCOMMISION'
    | 'FRONTCATEGORY_1_TOPSALES'
    | 'FRONTCATEGORY_1_TOPCOMMISION'
    | 'FRONTCATEGORY_2_TOPSALES'
    | 'FRONTCATEGORY_2_TOPCOMMISION'
    | 'FRONTCATEGORY_3_TOPSALES'
    | 'FRONTCATEGORY_3_TOPCOMMISION'
    | 'FRONTCATEGORY_4_TOPSALES'
    | 'FRONTCATEGORY_4_TOPCOMMISION'
    | 'FRONTCATEGORY_5_TOPSALES'
    | 'FRONTCATEGORY_5_TOPCOMMISION'
    | 'CREATIONCENTER'
    | 'ORIENTATION_PLAN'
    | 'ITEM_DETAIL'
    | 'CART_MEDIA_TYPE_OE_PHOTO_BIND'
    | 'PAGE_DISTRIBUTION'; // Page Source

export type IShelfSourceMap = {
    [key: string]: number;
};

export const SHELF_QUERY_KEY = 'shelf_source_map';
export const SHELF_SOURCE_LIST: { [key: string]: TShelfKeys } = {
    FLOOR_HOT: 'FLOOR_HOT',
    FLOOR_SAMPLE: 'FLOOR_SAMPLE',
    FLOOR_SUBSIDY: 'FLOOR_SUBSIDY',
    SEARCH_SALECOUNT: 'SEARCH_SALECOUNT',
    SEARCH_COMMISSION: 'SEARCH_COMMISSION',
    RECO_ALL: 'RECO_ALL',
    RECO_FRONTCATEGORY_FACALITYTOOLS: 'RECO_FRONTCATEGORY_FACALITYTOOLS',
    RECO_FRONTCATEGORY_HOUSEHOLDGOODS: 'RECO_FRONTCATEGORY_HOUSEHOLDGOODS',
    RECO_FRONTCATEGORY_FASHIONLADY: 'RECO_FRONTCATEGORY_FASHIONLADY',
    RECO_FRONTCATEGORY_BEAURYHEALTH: 'RECO_FRONTCATEGORY_BEAURYHEALTH',
    RECO_FRONTCATEGORY_ELECTRONIC: 'RECO_FRONTCATEGORY_ELECTRONIC',
    ALL_TOPSALES: 'ALL_TOPSALES',
    ALL_TOPCOMMISION: 'ALL_TOPCOMMISION',
    SHOP_RECO: 'SHOP_RECO',
    SHOP_TOPSALES: 'SHOP_TOPSALES',
    SHOP_TOPCOMMISION: 'SHOP_TOPCOMMISION',
    FRONTCATEGORY_1_TOPSALES: 'FRONTCATEGORY_1_TOPSALES',
    FRONTCATEGORY_2_TOPSALES: 'FRONTCATEGORY_1_TOPSALES',
    FRONTCATEGORY_3_TOPSALES: 'FRONTCATEGORY_3_TOPSALES',
    FRONTCATEGORY_4_TOPSALES: 'FRONTCATEGORY_4_TOPSALES',
    FRONTCATEGORY_5_TOPSALES: 'FRONTCATEGORY_5_TOPSALES',
    FRONTCATEGORY_1_TOPCOMMISION: 'FRONTCATEGORY_1_TOPCOMMISION',
    FRONTCATEGORY_2_TOPCOMMISION: 'FRONTCATEGORY_2_TOPCOMMISION',
    FRONTCATEGORY_3_TOPCOMMISION: 'FRONTCATEGORY_3_TOPCOMMISION',
    FRONTCATEGORY_4_TOPCOMMISION: 'FRONTCATEGORY_4_TOPCOMMISION',
    FRONTCATEGORY_5_TOPCOMMISION: 'FRONTCATEGORY_5_TOPCOMMISION',
    CREATIONCENTER: 'CREATIONCENTER',
    ORIENTATION_PLAN: 'ORIENTATION_PLAN',
    ITEM_DETAIL: 'ITEM_DETAIL',
    CART_MEDIA_TYPE_OE_PHOTO_BIND: 'CART_MEDIA_TYPE_OE_PHOTO_BIND',

    // 页面 Source
    PAGE_DISTRIBUTION: 'PAGE_DISTRIBUTION',
};

// 第一步：URL 获取 obj
export const getShelfObjectFromUrl = (): IShelfSourceMap => {
    const shelfMap: IShelfSourceMap = {};
    let shelfQuery = getQuery(SHELF_QUERY_KEY);
    if (!shelfQuery) {
        return {};
    }
    shelfQuery = decodeURIComponent(shelfQuery as string);
    const shelfArr = (shelfQuery as string).split(',');
    if (shelfArr.length === 0) {
        return {};
    }
    shelfArr.forEach(key => {
        const [k, v] = key.split('..');
        shelfMap[k] = Number(v);
    });
    return shelfMap;
};

// 第二步：更新 obj 中的某些内容
export const refreshShelfMap = (shelfMap: React.MutableRefObject<IShelfSourceMap>, key: TShelfKeys | '') => {
    if (!key) return;
    shelfMap.current = {
        ...shelfMap.current,
        [key]: Date.now(),
    };
};

// 【可选】第二步，不更新 obj，只返回新的 obj
export const setNewShelfMap = (shelfMap: React.MutableRefObject<IShelfSourceMap>, key: TShelfKeys | ''): IShelfSourceMap => {
    if (!key) return Object.assign({}, shelfMap.current);
    return Object.assign({}, shelfMap.current, {
        [key]: Date.now(),
    });
};

// 第三步：将 obj 转化为 string
export const getShelfQueryString = (shelfMap: IShelfSourceMap): string => {
    const keys = Object.keys(shelfMap);
    if (keys.length === 0) {
        return '';
    }
    const value = keys.map(key => `${key}..${shelfMap[key]}`).join(',');
    return encodeURIComponent(value);
};
